import React, { useState } from 'react';
import { useAutomationTest } from '../../hooks/useAutomations';
import { useToast } from '../../components/Toast';

const AutomationTestPanel = ({ trigger }) => {
    const { runTest, loading } = useAutomationTest();
    const { showError } = useToast();
    const [eventType, setEventType] = useState(trigger || 'lead.created');
    const [leadId, setLeadId] = useState('');
    const [dealId, setDealId] = useState('');
    const [activityId, setActivityId] = useState('');
    const [payload, setPayload] = useState({ status: '', source: '', stage: '', amount: '' });
    const [result, setResult] = useState(null);

    const buildEvent = () => {
        const id = `test_${Date.now()}`;
        const base = {
            id,
            ts: Date.now(),
            type: eventType,
            actor: { id: 'test' },
            entity: { type: 'lead', id: leadId || 'lead_test' },
            payload: {},
        };
        if (eventType.startsWith('deal')) {
            base.entity = { type: 'deal', id: dealId || 'deal_test' };
            base.payload = { deal: { stage: payload.stage, amount: payload.amount } };
        } else if (eventType.startsWith('activity')) {
            base.entity = { type: 'activity', id: activityId || 'activity_test' };
            base.payload = { activity: { status: payload.status, type: payload.stage } };
        } else {
            base.payload = { lead: { status: payload.status, source: payload.source } };
        }
        return base;
    };

    const handleRun = async () => {
        try {
            const data = await runTest(buildEvent());
            setResult(data);
        } catch (err) {
            showError(err.message || 'Test failed');
        }
    };

    return (
        <div>
            <div className="crm-form-grid">
                <div className="crm-form-group">
                    <label className="crm-label">Event Type</label>
                    <select className="crm-select" value={eventType} onChange={(e) => setEventType(e.target.value)}>
                        {[
                            'lead.created',
                            'lead.updated',
                            'deal.created',
                            'deal.stage_changed',
                            'activity.completed',
                            'activity.created',
                        ].map((type) => (
                            <option key={type} value={type}>{type}</option>
                        ))}
                    </select>
                </div>

                {eventType.startsWith('lead') && (
                    <>
                        <div className="crm-form-group">
                            <label className="crm-label">Lead ID</label>
                            <input className="crm-input" value={leadId} onChange={(e) => setLeadId(e.target.value)} />
                        </div>
                        <div className="crm-form-group">
                            <label className="crm-label">Status</label>
                            <input className="crm-input" value={payload.status} onChange={(e) => setPayload({ ...payload, status: e.target.value })} />
                        </div>
                        <div className="crm-form-group">
                            <label className="crm-label">Source</label>
                            <input className="crm-input" value={payload.source} onChange={(e) => setPayload({ ...payload, source: e.target.value })} />
                        </div>
                    </>
                )}

                {eventType.startsWith('deal') && (
                    <>
                        <div className="crm-form-group">
                            <label className="crm-label">Deal ID</label>
                            <input className="crm-input" value={dealId} onChange={(e) => setDealId(e.target.value)} />
                        </div>
                        <div className="crm-form-group">
                            <label className="crm-label">Stage</label>
                            <input className="crm-input" value={payload.stage} onChange={(e) => setPayload({ ...payload, stage: e.target.value })} />
                        </div>
                        <div className="crm-form-group">
                            <label className="crm-label">Amount</label>
                            <input className="crm-input" value={payload.amount} onChange={(e) => setPayload({ ...payload, amount: e.target.value })} />
                        </div>
                    </>
                )}

                {eventType.startsWith('activity') && (
                    <>
                        <div className="crm-form-group">
                            <label className="crm-label">Activity ID</label>
                            <input className="crm-input" value={activityId} onChange={(e) => setActivityId(e.target.value)} />
                        </div>
                        <div className="crm-form-group">
                            <label className="crm-label">Status</label>
                            <input className="crm-input" value={payload.status} onChange={(e) => setPayload({ ...payload, status: e.target.value })} />
                        </div>
                        <div className="crm-form-group">
                            <label className="crm-label">Type</label>
                            <input className="crm-input" value={payload.stage} onChange={(e) => setPayload({ ...payload, stage: e.target.value })} />
                        </div>
                    </>
                )}
            </div>

            <div className="crm-form-actions">
                <button className="crm-btn crm-btn-primary" onClick={handleRun} disabled={loading}>
                    {loading ? 'Running...' : 'Run Test'}
                </button>
            </div>

            {result && (
                <div className="crm-card" style={{ marginTop: '16px' }}>
                    <div className="crm-card-body">
                        <h4 style={{ marginTop: 0 }}>Matched automations</h4>
                        {result.automations && result.automations.length > 0 ? (
                            <ul>
                                {result.automations.map((entry) => (
                                    <li key={entry.automationId}>
                                        {entry.name} ({entry.actions.length} actions)
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="crm-muted">No automations would run.</p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default AutomationTestPanel;
